export function truncate( str: string | undefined, length: number = 30 ): string {
  if ( !str ) return 'N/A';
  return str.length > length ? str.substring( 0, length ) + '...' : str;
}
